'use strict';

module.exports = function ($stateProvider) {

    $stateProvider
        .state('dashboard.departments.department.forms', {
            url: '/forms',
            templateUrl: 'dashboard-forms/dashboard-forms.html',
            controller: 'dashboardFormsCtrl as ctrl',
            resolve: {
                forms: ['Department', '$stateParams', 'departments', '$state', 'Authentication', function (Department, $stateParams, departments, $state, Authentication) {
                   /*  return Authentication.loadDepartments().then(function(departments){
                        departments */
                        if (!$stateParams.departmentId && departments.length) {
                            let deptId = localStorage.getItem('lastDepartment');
                            let departmentExists = departments.find(dept => dept.id == deptId);
                            let targetDeptId = departmentExists ? deptId : departments[0].id;
                            return $state.go('dashboard.departments.department.forms', {
                                departmentId: targetDeptId
                            });
                        }
                        //const dept = departments.find(d => d.id == $stateParams.departmentId);
                        const deptOnlyViewer = Authentication.isOnlyViewerInDept();  //!(dept.owners && dept.owners.find(o => o.id == Authentication.currentUser()) != undefined);
                        if (deptOnlyViewer || Authentication.isAuthorized("viewer")) {
                            if(!Array.isArray(departments))
                                return {};
                            return departments.reduce(function (ret, item) {
                                if (item.id == $stateParams.departmentId)
                                    return item.forms
                                else
                                    return ret;
                             }, {});
                        } else
                            return Department.forms({
                                id: $stateParams.departmentId,
                                filter: {                                
                                    include: [{
                                        relation: 'teams',                                    
                                    }, 'tenant']
                                }
                            })
                                .$promise.then(function (forms) {
                                    return forms;
                                });
                }],
                departmentReportConfig: ['Department', '$stateParams', 'Authentication', function (Department, $stateParams, Authentication) {
                    if (!$stateParams.departmentId) {
                        return undefined;
                    }
                    const deptOnlyViewer = Authentication.isOnlyViewerInDept();  //!(dept.owners && dept.owners.find(o => o.id == Authentication.currentUser()) != undefined);
                    if (deptOnlyViewer || Authentication.isAuthorized("viewer")) 
                        return undefined;
                    return Department.findById({
                        id: $stateParams.departmentId
                    }).$promise.then(function (dept) {
                        return dept && dept.reportConfig;
                    });
                }]
            },
            data: {
                authorizedRoles: ['admin', 'mobileUser', 'viewer']
            }
        });
};